(() => {
  const previewId = new URLSearchParams(window.location.search).get('preview_theme_id');
  if (previewId) {
    const keepPreview = (root = document) => {
      root.querySelectorAll('a[href],form[action]').forEach((el) => {
        try {
          const attr = el.hasAttribute('href') ? 'href' : 'action';
          const url = new URL(el.getAttribute(attr), window.location.href);
          if (url.origin !== window.location.origin || url.pathname.startsWith('/admin') || url.pathname.startsWith('/checkouts')) return;
          if (!url.searchParams.has('view')) {
            const previewViews = [
              ['/products/home-ecosystems-smart-controller-mini', 'he-controller-mini'],
              ['/products/home-ecosystems-smart-control', 'he-controller'],
              ['/products/plantart-120', 'he-plantart-product'],
              ['/products/plantart-80', 'he-plantart-product'],
              ['/pages/controllers', 'he-controllers'],
              ['/pages/professional-solutions', 'he-professional-solutions'],
              ['/pages/partners', 'he-partners'],
              ['/pages/about', 'he-about'],
              ['/pages/getting-started', 'he-getting-started'],
              ['/pages/contact', 'he-contact'],
              ['/pages/supported-devices', 'he-supported-devices'],
              ['/pages/plantart', 'he-plantart']
            ];
            const match = previewViews.find(([path]) => url.pathname.endsWith(path));
            if (match) url.searchParams.set('view', match[1]);
          }
          if (!url.searchParams.has('preview_theme_id')) url.searchParams.set('preview_theme_id', previewId);
          el.setAttribute(attr, url.pathname + url.search + url.hash);
        } catch (_) {}
      });
    };
    document.addEventListener('DOMContentLoaded', () => keepPreview());
    new MutationObserver((records) => records.forEach((record) => record.addedNodes.forEach((node) => {
      if (node.nodeType === 1) keepPreview(node);
    }))).observe(document.documentElement, { childList: true, subtree: true });
  }
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.he-nav details[open]').forEach((item) => {
      item.removeAttribute('open');
      item.querySelector('summary')?.focus();
    });
  });
  document.addEventListener('click', (event) => {
    const purchaseLink = event.target.closest('[data-he-purchase-focus]');
    if (purchaseLink) {
      const purchaseTarget = document.querySelector('[id^="ProductInfo-"]');
      if (purchaseTarget) {
        event.preventDefault();
        purchaseTarget.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        purchaseTarget.focus({ preventScroll: true });
      }
    }
    const link = event.target.closest('a[href^="#he-interest-form"],a[href^="#he-form-"]');
    if (!link) return;
    const target = document.querySelector(link.getAttribute('href'));
    if (target) requestAnimationFrame(() => target.focus({ preventScroll: true }));
  });
  document.querySelectorAll('[data-he-form-success]').forEach((node) => node.focus());
})();